import {
  COLOR_MODE_KEY,
  INITIAL_COLOR_MODE_CSS_PROP,
  themeProperties,
} from './theme';
import Script from 'next/script';

export function setColorsByTheme() {
  const modeProperties = '[MODEPROPERTIES]';
  const colorModeKey = '[COLORMODEKEY]';
  const colorModeCssProp = '[COLORMODECSSPROP]';

  const mql = window.matchMedia('(prefers-color-scheme: dark)');
  const prefersDarkFromMq = mql.matches;
  const persistedPreference = localStorage.getItem(colorModeKey);

  let colorMode = 'light'; // default to dark

  const hasUsedToggle = typeof persistedPreference === 'string';

  if (hasUsedToggle) {
    colorMode = persistedPreference;
  } else {
    //Dark 모드 제거
    //colorMode = prefersDarkFromMq ? 'dark' : 'light';
    colorMode = 'light';
  }

  const root = document.documentElement;

  root.style.setProperty(colorModeCssProp, colorMode);

  // 앱 웹뷰 다크 모드 (styles/appDarkMode.ts shouldUseAppDarkMode 와 같은 규칙) — 하이드레이션 전에 표시해 깜빡임 없이 시작.
  // 다크를 허용한다고 알려 준 앱(window.portalAppColorScheme)에서만. 예전 앱은 늘 라이트.
  // 세일즈(/m/sales · /m/newsales)는 앱이 다크여도 라이트 고정 — appDarkMode.ts APP_LIGHT_ONLY_PATH_PREFIXES 와 같은 목록
  // (이 함수는 문자열로 심어져 import 를 못 한다)
  const lightOnly = ['/m/sales', '/m/newsales'].some((prefix) =>
    window.location.pathname.startsWith(prefix),
  );
  // @ts-ignore
  const appScheme = window.ReactNativeWebView
    ? window.portalAppColorScheme
    : undefined;
  const appDark =
    !lightOnly &&
    (appScheme === 'dark' || (appScheme === 'system' && prefersDarkFromMq));
  root.setAttribute('data-color-mode', appDark ? 'dark' : 'light');
  root.style.colorScheme = appDark ? 'dark' : 'light';

  // generating css variables based on modeProperties
  Object.entries(modeProperties).forEach(([name, colorByTheme]) => {
    const cssVarName = `--${name}`;
    // @ts-ignore
    root.style.setProperty(cssVarName, colorByTheme[colorMode]);
  });
}

const ScriptTag = () => {
  const stringifyFn = String(setColorsByTheme)
    // eslint-disable-next-line quotes
    .replace('"[MODEPROPERTIES]"', JSON.stringify(themeProperties))
    .replace('[COLORMODEKEY]', COLOR_MODE_KEY)
    .replace('[COLORMODECSSPROP]', INITIAL_COLOR_MODE_CSS_PROP);

  const fnToRunOnClient = `(${stringifyFn})()`;

  return (
    <Script
      strategy={'beforeInteractive'}
      dangerouslySetInnerHTML={{ __html: fnToRunOnClient }}
    />
  );
};

export default ScriptTag;
